export function initAlerts() {
    document.querySelectorAll('.alert').forEach(alert => {
        alert.querySelector('button.close')?.addEventListener('click', () => {
            alert.remove();
        });
    })
}